/**
 * @generated SignedSource<<97e62843878afb25d77ce5a74b084c17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type boardFilterRefinement_softwareBoard$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_filterRefinement_FilterRefinement">;
  readonly " $fragmentType": "boardFilterRefinement_softwareBoard";
};
export type boardFilterRefinement_softwareBoard$key = {
  readonly " $data"?: boardFilterRefinement_softwareBoard$data;
  readonly " $fragmentSpreads": FragmentRefs<"boardFilterRefinement_softwareBoard">;
};

import boardFilterRefinementRefetchQuery_graphql from './boardFilterRefinementRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "scope"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": boardFilterRefinementRefetchQuery_graphql
    }
  },
  "name": "boardFilterRefinement_softwareBoard",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "scope",
          "variableName": "scope"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ui_filterRefinement_FilterRefinement"
    }
  ],
  "type": "Query"
};

(node as any).hash = "9bf0ca6b005e985814f36248385113e3";

export default node;
